// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { EMRPacServerType } from "../../types";
import { getEMRPacServers } from "../../api";

export const useEMRPacServers = (
  clinicId: string | undefined,
  hubId: string | undefined
) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<EMRPacServerType>>({
    queryKey: ["emr-pac-servers", clinicId, hubId],
    queryFn: async () => {
      if (!clinicId || !hubId) throw new Error();
      const token = await getToken();
      return getEMRPacServers(token, clinicId, hubId);
    },
    enabled: Boolean(clinicId && hubId),
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
};
